
import { mdiMenuUp, mdiMenuDown } from '@mdi/js'
import { mapState } from 'vuex'

export default {

  props: {
  },
  data: () => ({
    mdiMenuUp,
    mdiMenuDown,
    expanded: false,
    descriptionClass: 'not-expanded',
    switchDescriptionTranslation: false,
    switchDefectsDescriptionTranslation: false,
    defectsExistsAttribute: {}
  }),
  async fetch () {
    const { data } = await this.$axios.get('/public/attributes/get/product/de/defects_exists')
    this.defectsExistsAttribute = data
  },

  computed: {
    ...mapState('product', {
      attributes: state => state.data?.attributes,
      description: state => state.data?.description,
      translatedDescription: state => state.translatedDescription,
      defectsDescription: state => state.data?.defectsDescription,
      translatedDefectsDescription: state => state.translatedDefectsDescription
    }),

    defectsExist () {
      if (this.defectsExistsAttribute?.attributeId) {
        const yesOption = this.defectsExistsAttribute.options.find(option => option.label.toLowerCase() === 'ja')
        return this.attributes[this.defectsExistsAttribute.attributeId]?.value === yesOption?.optionId
      } else {
        return false
      }
    },

    defectsDescriptionNotEmpty () {
      return this.defectsDescription && this.defectsDescription.length > 0
    },

    icon () {
      if (this.expanded) {
        return this.mdiMenuUp
      } else {
        return this.mdiMenuDown
      }
    },
    buttonText () {
      if (this.expanded) {
        return this.$t('hide_information')
      } else {
        return this.$t('show_all_information')
      }
    },
    maybeTranslatedDescription () {
      if (this.translatedDescription) {
        if (this.switchDescriptionTranslation) {
          return this.description
        } else {
          return this.translatedDescription
        }
      } else {
        return this.description
      }
    },
    maybeTranslatedDefectsDescription () {
      if (this.translatedDefectsDescription) {
        if (this.switchDefectsDescriptionTranslation) {
          return this.defectsDescription
        } else {
          return this.translatedDefectsDescription
        }
      } else {
        return this.defectsDescription
      }
    },
    switchDescriptionTranslationButtonText () {
      if (!this.switchDescriptionTranslation) {
        return 'de'
      } else {
        return this.$i18n.locale
      }
    },
    switchDefectsDescriptionTranslationButtonText () {
      if (!this.switchDefectsDescriptionTranslation) {
        return 'de'
      } else {
        return this.$i18n.locale
      }
    }

  },

  methods: {
    toggleDescriptionTranslation () {
      this.switchDescriptionTranslation = !this.switchDescriptionTranslation
    },
    toggleDefectsDescriptionTranslation () {
      this.switchDefectsDescriptionTranslation = !this.switchDefectsDescriptionTranslation
    },

    toggleExpanded () {
      this.expanded = !this.expanded
      if (this.expanded) {
        this.descriptionClass = 'expanded'
      } else {
        this.descriptionClass = 'not-expanded'
      }
    }
  }
}
